export const columnsLocal=(t) => [
  // {
  //   title: '',
  //   dataIndex: 'hash',
  //   key: 'hash',
  //   width: '50px'
  // },
  // {
  //   title: t('COLUMN_CR_NO'),
  //   dataIndex: 'Cr_no',
  //   key: 'Cr_no'
  // },
  {
    title: t('COLUMN_BRN'),
    dataIndex: 'Brn',
    key: 'Brn'
  },
  {
    title: t('COLUMN_LOCAL_COM_CHI_NAME'),
    dataIndex: 'Local_com_chinese_name',
    key: 'name_reg_chinese',
    render: (val)=>(val?val==="NULL"?"":val:"")
  },
  {
    title: t('COLUMN_LOCAL_COM_ENG_NAME'),
    dataIndex: 'Local_com_eng_name',
    key: 'name_reg_eng',
    render: (val)=>(val?val==="NULL"?"":val:"")
  },
  {
    title: t('COLUMN_REGISTERED_OFFICE'),
    dataIndex: 'Local_com_reg_office',
    key: 'address',
    render: (val)=>(val?val==="NULL"?"":val:"")
  },
  {
    title: t('COLUMN_COM_TYPE'),
    dataIndex: 'Company_type',
    key: 'company_type',
    render: (val)=>(val?val==="NULL"?"":val:"")
  },
  {
    title: t('COLUMN_DATE_OF_INCORPORATION'),
    dataIndex: 'Date_of_incorporation',
    key: 'date_of_incorporation',
    // render: (val)=>(typeof val)
    // width:'100px'
  },
  {
    title: t('COLUMN_DATE_OF_REDOMICILIATION'),
    dataIndex: 'Date_of_redomiciliation',
    key: 'Date_of_redomiciliation',
    // render: (val)=>(typeof val)
    // width:'100px'
  }
]

export const columnsForeign=(t) => [
  // {
  //   title: '',
  //   dataIndex: 'hash',
  //   key: 'hash',
  //   width: '50px',
  // },
  // {
  //   title: t('COLUMN_CR_NO'),
  //   dataIndex: 'Cr_no',
  //   key: 'Cr_no',
  //   width:'100px'
  // },
  {
    title: t('COLUMN_BRN'),
    dataIndex: 'Brn',
    key: 'Brn',
    width:'100px'
  },
  {
    title: t('COLUMN_CORPORATE_NAME'),
    dataIndex: 'Corp_name',
    key: 'Corp_name',
    width:'100px',
    render: (val)=>(val?val==="NULL"?"":val:"")
  },
  {
    title: t('COLUMN_CORPORATE_APPROVED_NAME'),
    dataIndex: 'Corp_trade_name',
    key: 'Corp_trade_name',
    width:'100px',
    render: (val)=>(val?val==="NULL"?"":val:"")
  },
  {
    title: t('COLUMN_OTHER_CORPORATE_NAME'),
    dataIndex: 'Other_corp_names',
    key: 'Other_corp_names',
    width:'100px',
    render: (val)=>(val?val==="NULL"?"":val:"")
  },
  {
    title: t('COLUMN_OTHER_CORPORATE_APPROVED_NAME'),
    dataIndex: 'Other_corp_trade_name',
    key: 'Other_corp_trade_name',
    width:'100px',
    render: (val)=>(val?val==="NULL"?"":val:"")
  },
  {
    // title: 'Principle Place of Business',
    title: t('COLUMN_PRINCIPAL_PLACE_OF_BUSINESS'),
    dataIndex: 'Principal_place_of_business',
    key: 'Principal_place_of_business',
    width:'100px',
    render: (val)=>(val?val==="NULL"?"":val:"")
  },
  // {
  //   title: 'Trading Address used in HK',
  //   dataIndex: 'trading_address',
  //   key: 'trading_address',
  //   width:'100px'
  // },
  {
    title: t('COLUMN_PLACE_OF_INCORPORATION'),
    dataIndex: 'Place_of_incorporation',
    key: 'Place_of_incorporation',
    width:'100px',
    render: (val)=>(val?val==="NULL"?"":val:"")
  },
  {
    title: t('COLUMN_COM_TYPE'),
    dataIndex: 'Company_type',
    key: 'Company_type',
    width:'100px',
    render: (val)=>(val?val==="NULL"?"":val:"")
  },
  {
    title: t('COLUMN_DATE_OF_REGISTRATION'),
    dataIndex: 'Date_of_registration',
    key: 'Date_of_registration',
    width:'100px'
  }
]


// WEBPACK FOOTER //
// src/components/SearchResult/TableColumns.js